import React, { useState } from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import UploadManualData from '../tabs-content/UploadManualData'
import UploadPreviewContent from '../tabs-content/UploadPreviewContent'

const UploadCustomDataContent = () => {
  const [key, setKey] = useState("upload-data")
  const [isUpload, setIsUpload] = useState(true)
  const handleTabChange = (value) => {
    setKey(value)
    setIsUpload(true)
  }
  return (
    <div className='enter-manual-data-content'>
      <Tabs  defaultValue={key} value={key}  className="w-[full]" onValueChange={handleTabChange}>
        <div className="tabs-wrapper mb-6">
          <TabsList className="inline-flex shadow-none p-0 w-[240px]">
            <TabsTrigger className="px-5 py-2 flex-grow w-full !text-[#6C7B90] data-[state=active]:!text-theme border border-[#DADFD8] rounded-none data-[state=active]:border-theme data-[state=active]:!bg-[#F0F6FC] rounded-tl-[4px] rounded-bl-[4px]" value="upload-data">Upload File</TabsTrigger>
            <TabsTrigger className="px-5 py-2 flex-grow w-full !text-[#6C7B90] data-[state=active]:!text-theme border border-[#DADFD8] rounded-none data-[state=active]:border-theme data-[state=active]:!bg-[#F0F6FC] rounded-tr-[4px] rounded-br-[4px]" value="preview" > Preview</TabsTrigger>
          </TabsList>
        </div>
        <div className="">
          <TabsContent value="upload-data" className="m-0">
            <UploadManualData setKey={setKey} isUpload={isUpload} setIsUpload={setIsUpload}/>
          </TabsContent>
          <TabsContent value="preview">
            <UploadPreviewContent keyName={key} isUpload={isUpload} setIsUpload={setIsUpload}/>
          </TabsContent>
        </div>
      </Tabs>
    </div>
  )
}

export default UploadCustomDataContent